import { z } from 'zod';
import { request } from './client';

export const defaultPermissionSchema = z.enum(['view', 'comment', 'edit']);
export type DefaultPermission = z.infer<typeof defaultPermissionSchema>;

export const workspaceSettingsSchema = z.object({
  workspaceId: z.string(),
  defaultPermission: defaultPermissionSchema,
  allowPublicSharing: z.boolean(),
  inviteLinkToken: z.string().nullable(),
  updatedAt: z.string(),
});
export type WorkspaceSettings = z.infer<typeof workspaceSettingsSchema>;

export const settingsApi = {
  /** 获取空间设置 */
  get: (wsId: string) => request<WorkspaceSettings>(`/workspaces/${wsId}/settings`),

  /** 更新空间设置 */
  update: (
    wsId: string,
    body: { defaultPermission?: DefaultPermission; allowPublicSharing?: boolean },
  ) =>
    request<{ workspaceId: string; updated: boolean }>(`/workspaces/${wsId}/settings`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
};
